import React, { useContext, useEffect, useState } from "react";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { Tooltip } from "@mui/material";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import {
  PrasadCategoryLookupList,
  PrasadDataList,
} from "../../ApiServices/Prasad/PrasadApi";
import Select from "react-select";
import Breadcrumbs from "../Breadcrumb";
import { customSelectStyles } from "../../middlewares/Utils";
import { TempleLookUpList } from "../../ApiServices/Temple/TempleApi";

const PrasadList = () => {
  const [mydata, setMydata] = useState([]);
  const [mydataMobile, setMydataMobile] = useState([]);
  const [Product, setProduct] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [noElement, setNoElement] = useState(12);
  const [catId, setCatId] = useState(null);
  const [selectedCatId, setSelectedCatId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation()
  const { setLoader, loader, activeCategory, setActiveCategory } =
    useContext(LoaderContext);

  useEffect(() => {
    // setLoader(true)
    // axios
    //     .get(`${BaseUrl}/ProductCategory`)
    //     .then((res) => {
    //         const responseData = res.data.DATA || [];
    //         setLoader(false)
    //         // setMydata(responseData);
    //         console.log(responseData);
    //         setCatId(responseData[0].CAT_ID);
    //         setSelectedCatId(responseData[0].CAT_ID);
    //     })
    //     .catch((err) => {
    //         setLoader(false)
    //         console.log(err);
    //     });

    GetProductCategoryList();
    // setShowModal(true)
  }, []);

  useEffect(() => {
    if (catId !== null && catId !== undefined && catId !== "") {
      GetPrasadListData();
    }
  }, [catId]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Adjust breakpoint as needed
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const GetProductCategoryList = async () => {
    setLoader(true);
    try {
      let response = await TempleLookUpList(); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);

        const list = response?.DATA || [];
        const FilteredList = list
          .filter((item) => item.TempleCount > 0)
        console.log("response", response);
        setMydata(FilteredList);
        const options = FilteredList
          .filter((item) => item.TempleID && item.TempleName)
          .map((item) => ({
            value: item.TempleID,
            label: item.TempleName,
          }));
        setMydataMobile(options);

        const storedCatId = sessionStorage.getItem("selectedCatId");
        if (location?.state?.ID !== null && location?.state?.ID !== undefined) {
          setCatId(location?.state?.ID);
          setSelectedCatId(location?.state?.ID);
        } else if (Number(storedCatId)) {
          setCatId(Number(storedCatId));
          setSelectedCatId(Number(storedCatId));
        } else {
          setCatId(FilteredList[0].TempleID);
          setSelectedCatId(FilteredList[0].TempleID);
        }
        // setCatId(list[0].PrasadCatID);
        // setSelectedCatId(list[0].PrasadCatID);
      } else {
        console.error("Bad request");
        // setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  const GetPrasadListData = async () => {
    const data = localStorage.getItem("userID") || "";
    // if (data === null || data === undefined || data === "") {
    //   return;
    // }
    setLoader(true);
    try {
      const response = await PrasadDataList(
        {
          START: 0,
          END: 100,
          WORD: "none",
        },
        catId,
        data
      );

      if (response?.ResponseCode == "0") {
        const responseData = response?.DATA || [];
        setLoader(false);
        const allProducts = [];
        // responseData.forEach((category) => {
        //     if (Array.isArray(category.PRODUCT_LIST)) {
        //         category.PRODUCT_LIST.forEach((product) => {
        //             allProducts.push(product);
        //         });
        //     }
        // });
        setProduct(responseData);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const Slice = Product.slice(0, noElement);
  const viewMore = (e) => {
    e.preventDefault();
    setNoElement((prevNoElement) => prevNoElement + 12);
  };
  console.log("selectedCatId", selectedCatId);

  const addToCart = (product) => {

    const newSlug = product?.PrasadSlug;
    if (catId) {
      sessionStorage.setItem("selectedCatId", catId);
    }
    navigate(`/prasad-details/${newSlug}`);
    // navigate("/prasad-details", { state: product });
  };

  const handleClear = () => {
    setSearch("");
  };
  const handleCategoryChange = (value) => {
    setCatId(value);
    setSelectedCatId(value);
  };
  return (
    <>
      <section >
        <div className="container">
          <div className="container-fluid py-4">
            <div style={{ padding: "8px" }}>
              <Breadcrumbs />
            </div>
            <div className="row">
              {!isMobile && (
                <div
                  className="left col-md-3 col-sm-4 "
                // style={{ marginLeft: "10px" }}
                >
                  <h4
                    className=" custom-list-item clearfix"
                    style={{
                      fontFamily: "poppins",
                      fontSize: "20px",
                      borderBottom: "1px solid lightgray",
                      textTransform: "none",
                      padding: "12px",
                    }}
                  >
                    Prasad Categories
                  </h4>
                  <ul className="margin-bottom-25 sidebar-menu">
                    {mydata?.length > 0 ? (
                      mydata.map((category, index) => (
                        <li
                          className="list-group-item clearfix"
                          // style={{ padding: "10px 15px" }}
                          key={category.TempleID}
                        >
                          <Link
                            to={"/prasad-list"}
                            onClick={() =>
                              handleCategoryChange(category.TempleID)
                            }
                            className={`d-flex align-items-center text-decoration-none ${selectedCatId === category.TempleID
                              ? "fw-bold #baf8f3"
                              : "text-dark"
                              }`}
                            style={{ color: `${selectedCatId === category.TempleID ? '#a52444' : 'grey'}`, textWrap: 'nowrap' }}
                          >
                            {/* <img
                      src={category.PUJACAT_ICON}
                      alt={category.PUJACAT_NAME}
                      className="puja-icon"
                      style={{
                        width: "30px",
                        height: "30px",
                        objectFit: "cover",
                        marginRight: "10px",
                        borderRadius: "50%",
                      }}
                    /> */}
                            <i className="fa fa-angle-right me-2"></i>
                            {/* <span>{category.CAT_NAME}</span> */}
                            {category.TempleName?.length > 30 ? (
                              <Tooltip title={category.TempleName}>
                                {`${category.TempleName.substring(
                                  0,
                                  19
                                )}...`}
                              </Tooltip>
                            ) : (
                              category.TempleName
                            )}
                          </Link>
                        </li>
                      ))
                    ) : (
                      <li className="list-group-item">
                        No categories available
                      </li>
                    )}
                  </ul>
                </div>
              )}
              {/* Main Content */}
              <main className="col-md-9 col-sm-8">
                {/* Search Bar */}
                {!isMobile ? (
                  <div
                    className="mb-4 custom-search"
                    style={{ marginLeft: "22px" }}
                  >
                    <input
                      type="text"
                      className="custom-search-input"
                      placeholder="Search Product"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                ) : (
                  <div style={{ marginBottom: "20px" }}>
                    <Select
                      styles={customSelectStyles}
                      options={mydataMobile}
                      placeholder="Select Category"
                      value={mydataMobile.find(
                        (option) => option.value === catId
                      )}
                      onChange={(selectedOption) => {
                        setCatId(selectedOption.value);
                        setSelectedCatId(selectedOption.value);
                      }}
                    />
                  </div>
                )}

                {/* Product Grid */}
                <div
                  className="row "
                  style={{
                    minHeight: "50vh",
                    justifyContent: "left",
                    marginLeft: "20px",
                  }}
                >
                  {Slice?.filter((product) =>
                    search
                      ? product.PrasadName.toLowerCase().includes(
                        search.toLowerCase()
                      )
                      : true
                  ).length > 0 ? (
                    Slice.filter((product) =>
                      search
                        ? product.PrasadName.toLowerCase().includes(
                          search.toLowerCase()
                        )
                        : true
                    ).map((product, index) => (
                      <div
                        key={index}
                        className="col-xl-4 col-lg-6 col-md-6 col-sm-6 rounded"
                      >
                        <div
                          className="card shadow-md product-card"
                          onClick={() => addToCart(product)}
                          style={{
                            cursor: "pointer",
                            maxWidth: isMobile ? "20em" : "250px",
                            border: "none",
                            height: "350px", // ✅ fixed height for all cards
                          }}
                        >
                          <div
                            className="card-img-container"
                            style={{ height: "200px", overflow: "hidden" }}
                          >
                            <img
                              src={product.PrasadPhotoURL}
                              alt={product.PrasadName}
                              className="card-img-top"
                              style={{ height: "100%", objectFit: "contain" }}
                            />
                          </div>
                          <div
                            className="card-body p-1 d-flex flex-column"
                            style={{ width: "13rem" }}
                          >
                            <h6
                              style={{
                                fontSize: "18px",
                                color: "#8f3246",
                                fontWeight: "600",
                                textAlign: "center",
                              }}
                            >
                              {product.PrasadName.slice(0, 30)}
                            </h6>
                            <p
                              className="card-text mb-2"
                            // style={{ textAlign: "center" }}
                            >
                              <span
                                style={{
                                  color: "#a52444",
                                  fontSize: "20px",
                                }}
                              >
                                Rs{" "}
                                {product.PrasadPrice -
                                  Math.round(
                                    (product.PrasadPrice * product.Discount) /
                                    100
                                  )}
                              </span>
                              {product.Discount !== null &&
                                Number(product.Discount) !== 0 &&
                                product.Discount !== undefined ? (
                                <span
                                  className="text-muted ms-2"
                                  style={{ fontSize: "20px" }}
                                >
                                  <s>Rs {product.PrasadPrice}</s>
                                </span>
                              ) : (
                                ""
                              )}
                            </p>
                            <div className="d-flex justify-content-between align-items-center">
                              {product.Discount !== null &&
                                Number(product.Discount) !== 0 &&
                                product.Discount !== undefined ? (
                                <span
                                  style={{
                                    background: "#a52444",
                                    padding: "10px 13px",
                                    cursor: "text",
                                  }}
                                  className="badge"
                                >
                                  {product.Discount}% Off
                                </span>
                              ) : (
                                ""
                              )}

                              <button
                                className="Normal-app-btn ms-auto"
                                style={{
                                  padding: "5px 10px",
                                  fontSize: "12px",
                                }}

                              >
                                View Details{" "}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div
                      className="col-12 d-flex justify-content-center align-items-center"
                      style={{ minHeight: "300px" }}
                    >
                      {search ? (
                        <div className="text-center">
                          <img src={Batuk} alt="" />
                          <h5 className="text-muted">No products found</h5>
                          <button
                            className="btn btn-outline-secondary mt-3"
                            onClick={handleClear}
                          >
                            Clear Search
                          </button>
                        </div>
                      ) : (
                        !loader && (
                          <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
                            <img
                              src={Batuk}
                              alt="Empty Cart"
                              className="img-fluid mb-3"
                              style={{ maxWidth: "200px" }}
                            />
                            <h5 className="fw-bold">
                              No products available for this catagory
                            </h5>
                            <p className="text-muted">
                              Please explore our other categories.
                            </p>
                            {/* <Link to="/my-store">
                    <button
                      style={{ background: "#a52444" }}
                      className="text-white btn me-2"
                    >
                      Add Products
                    </button>
                  </Link> */}
                          </div>
                        )
                      )}
                    </div>
                  )}
                </div>

                {/* View More Button */}
                {noElement < Product.length && (
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      className="btn btn-warning px-4 py-2"
                      onClick={viewMore}
                    >
                      View More Products
                    </button>
                  </div>
                )}
              </main>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrasadList;
